<template>
  <div>
    <header class="modal-header">Thanks for submitting your return request</header>
    <section class="modal-body">
      <p v-if="autoRedistributed">
        Since you had issues with your last crew we are going to find another crew to come back and
        make your lawn beautiful ASAP.
      </p>
      <LsNumberedList
        v-else
        :items="[
          'We will work with your original crew to schedule a return visit',
          'We give your crew 24 hours to respond a pick a day to come back and fix the property',
          'If your crew can’t fix the issue we will assign a new crew to come back and make your lawn beautiful',
        ]"
      />
    </section>
    <footer class="modal-footer">
      <LsButton text="ok" track-id="return_request_fix_requested-ok" @click="close" />
    </footer>
  </div>
</template>

<script>
import { LsButton, LsNumberedList } from '@/components/common';
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: 'ReturnRequestFixRequested',
  components: {
    LsButton,
    LsNumberedList,
  },
  computed: {
    ...mapState(['dispute']),
    autoRedistributed() {
      return _.includes(
        _.get(this.dispute.currentDispute, 'dispute_status', ''),
        'auto_redistributed'
      );
    },
  },
  methods: {
    close() {
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
